import React from 'react'
import { Box } from '@mui/material'

/**
 * ResizeGrip.jsx — story 215 (PO, 20/10/2026).
 * The two short lines in the middle of a resize bar that say "this can be dragged". Horizontal on a bar that
 * moves up and down, vertical on an edge that moves sideways. The bar that holds it gives it its contrast on
 * hover through `'&:hover > *': { borderColor }`.
 */
const ResizeGrip = ({ vertical = false }) => (
  <Box
    data-testid='resize-grip'
    sx={vertical
      ? { width: 4, height: 28, borderLeft: 1, borderRight: 1, borderColor: 'text.secondary' }
      : { width: 28, height: 4, borderTop: 1, borderBottom: 1, borderColor: 'text.secondary' }}
  />
)

export default ResizeGrip
